import day from 'design-system/colors/day';
import night from 'design-system/colors/night';
import useColorScheme from './useColorScheme';
import { useEnforcedColorScheme } from './EnforcedColorSchemeContext';
const useColors = () => {
    const colorScheme = useColorScheme();
    const enforcedColorScheme = useEnforcedColorScheme();
    const effectiveScheme = enforcedColorScheme ?? colorScheme;
    return effectiveScheme === 'dark' ? night : day; // feature flag is checked in `useColorScheme`
};
/**
 * @param gradientKey Takes least priority. May be omitted only when `colorKey` is set
 * @param gradientColors Takes precedence
 * @param overrideColor Used only when `gradientColors` is omitted
 * @param colorKey Used when both `gradientColors` and `overrideColor` are not set
 * @returns [colorA, colorB]
 */
export const useGradientColors = (
/**
 * Takes least priority. May be omitted only when `colorKey` is set
 */
gradientKey, 
/**
 * Takes precedence
 */
gradientColors, 
/**
 * Used only when `gradientColors` is omitted
 */
overrideColor, colorKey) => {
    const colors = useColors();
    if (gradientColors) {
        return gradientColors;
    }
    if (overrideColor) {
        return [overrideColor, overrideColor];
    }
    if (colorKey) {
        return [colors.elements[colorKey], colors.elements[colorKey]];
    }
    if (gradientKey) {
        return colors.gradients[gradientKey].colors;
    }
    return [colors.elements.primary, colors.elements.primary];
};
/**
 * WARNING: This function doesn’t perform any feature flag logic and should only be used inside of navigationOptions callback.
 * @param colorScheme The `theme` argument from navigation options
 * @returns Correct color set for given color scheme.
 */
export const getColorsFromColorScheme = (colorScheme) => (colorScheme === 'dark' ? night : day);
export default useColors;
